import React, { Component } from 'react'
import { Router, Route, Redirect, Switch, useParams } from 'react-router-dom'
import { createHashHistory } from 'history'
import queryString from 'query-string'
import './App.css';
import ProtectedRoute from './Components/ProtectedRoute';
import Login from './Components/Login'; 
import PasswordNew from './Components/PasswordNew';
import PasswordReset from './Components/PasswordReset';
import Registration from './Components/Registration';
import RegistrationSuccessful from './Components/RegistrationSuccessful';
import Profile from './Components/Profile';
import ForgotPassword from './Components/ForgotPassword';
import ForgotUsername from './Components/ForgotUsername';
import PasswordSent from './Components/PasswordSent';
import NotificationBox from './Components/NotificationBox';
import Activation from './Components/Activation';
import Reactivation from './Components/Reactivation';
import GoogleTranslate from './Components/GoogleTranslate';
import AppMenu from './Components/AppMenu';
import GenericError from './Components/GenericError';
import Maintenance from './Components/Maintenance';
import Default from './Components/Default';
import Logout from './Components/Logout';
import { getMyProfile } from './utils/authService';

const history = createHashHistory();

class App extends Component {
  state = {
    notification: null,
    notificationIsActive: false,
    passwordSent: false,
    accountRegister: false,
    accessToken: sessionStorage.getItem('idcsToken'),
    userProfile: {
      givenName: '',
      familyName: '',
      email: '',
      id: '',
    }
  };

  setAccessToken = (token) => {
    sessionStorage.setItem('idcsToken', token);
    this.setState({
      accessToken: token
    });
    history.push('/apps');
  }

  removeAccessToken = () => {
    sessionStorage.removeItem('idcsToken');
    this.setState({
      accessToken: null,
      userProfile: {
        givenName: '',
        familyName: '',
        email: '',
        id: '',
      }
    });
    history.push('/login');
  }

  getUserProfile = (token) => {
    return getMyProfile(token).then(({ data }) => {
      const { givenName, familyName } = data.name;
      const userName = data.userName;
      const email = data.emails.find(e => e.primary === true).value;
      const id = data.id;
      
      let phone = '';
      if (data.phoneNumbers && data.phoneNumbers.some(p => p.type === 'mobile')) {
        phone = data.phoneNumbers.find(e => e.type === 'mobile').value;
      }
      else {
        console.log('Mobile Phone Undefined');
      }

      this.setState({
        userProfile: { givenName, familyName, userName, email, phone, id }
      });
    }).catch(error => {
      this.removeAccessToken();
    });
  }

  setUserProfile = (user) => {
    this.setState({
      userProfile: user
    });
  }

  resetSendPasswordStatus = () =>{
    this.setState({ 
      passwordSent: '',
    }); 
  }

  setSendPasswordEmail = (status) => {
    this.setState({ 
      passwordSent: status,
    });
  }

  showNotification = (notification) => {
    this.setState({ 
      notificationIsActive: true,
      notification,
    });
  }

  hideNotification = () => {
    if (this.state.notificationIsActive) {
      this.setState({
        notification: {},
        notificationIsActive: false,
      });
    }
  }

  componentDidMount() {
    this.unlisten = history.listen((location, action) => {
      const activated = sessionStorage.getItem('activated');
      if (activated) {
        sessionStorage.removeItem('activated');
      } else {
        this.hideNotification();
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
    }

    getAppName = () => {
        return useParams().appName
    }
   
  renderApp = () => {
    return (
      <Router history={history}>
        <div className="container app-container">
          <div className="row">
            <div className="translate-dropdown-align">
              <GoogleTranslate />
            </div> 
            { this.state.notificationIsActive && <NotificationBox notification={this.state.notification} hide={this.hideNotification} /> }
              <img src={ require('./logo.jpg') } className="App-logo" name="logo"  alt="City of Seattle"/>
              <div className="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-10 col-md-offset-1">
                <Switch>
                  <Route path="/login" exact render={
                    () => (
                      this.state.accessToken ? 
                      <Redirect to="/apps" /> :
                      <Login showNotification={this.showNotification} hideNotification={this.hideNotification} setAccessToken={this.setAccessToken} /> 
                    )
                  }/>
                  <Route path="/(forgot-password|password-sent)" exact render={ ()=> (
                    this.state.passwordSent ? 
                      <PasswordSent resetSendPasswordStatus={this.resetSendPasswordStatus} /> :
                      <ForgotPassword showNotification={this.showNotification} hideNotification={this.hideNotification} setSendPasswordEmail={this.setSendPasswordEmail}/> 
                  )} />
                  <Route path="/forgot-username" exact render={ ()=> (
                       <ForgotUsername showNotification={this.showNotification} hideNotification={this.hideNotification} setSendPasswordEmail={this.setSendPasswordEmail}/> 
                            )} />
                            <Route path="/logout" exact render={() => (
                                <Logout/>
                            )} />
                  <Route path="/password-reset" exact render={
                    () => (
                      history.location.search.indexOf('?token=') >= 0 ?
                      <PasswordReset qsValue={history.location.search} showNotification={this.showNotification} hideNotification={this.hideNotification} history={history} getUserProfile={this.getUserProfile} setUserProfile={this.setUserProfile} userProfile={this.state.userProfile} /> :
                            <Redirect to="/login" />
                    )
                  } />
                  <Route path="/activation" exact render={
                    () => {
                      const queryValues = queryString.parse(history.location.search);
                      return (
                        queryValues.token ?
                        <Activation token={queryValues.token} showNotification={this.showNotification} hideNotification={this.hideNotification} history={history} /> :
                              <Redirect to="/login" />
                      )
                      
                    }
                  } />
                  <Route path="/reactivation" exact render={
                    () => {
                      return (
                          <Reactivation showNotification={this.showNotification} hideNotification={this.hideNotification} history={history} />
                      )
                    }
                  } />
                  <Route path="/registration" exact render={ () =>(
                    this.state.accountRegister ? 
                    <Redirect to="/registration-successful" /> :
                    <Registration showNotification={this.showNotification} hideNotification={this.hideNotification} setAccessToken={this.setAccessToken} history={history} />
                  )} />
                  <Route path="/registration-successful" exact render={ () =>(
                    <RegistrationSuccessful showNotification={this.showNotification} hideNotification={this.hideNotification} history={history} setAccessToken={this.setAccessToken} />
                  )} />
                  <Route path="/apps" exact render={ () => ( 
                    <AppMenu showNotification={this.showNotification} notificationIsActive={this.state.notificationIsActive} /> 
                  )} />
                  <ProtectedRoute exact path="/password-new" accessToken={this.state.accessToken} component={PasswordNew} showNotification={this.showNotification} hideNotification={this.hideNotification} history={history} getUserProfile={this.getUserProfile} userProfile={this.state.userProfile} />
                  <ProtectedRoute exact path="/profile" accessToken={this.state.accessToken} component={Profile} showNotification={this.showNotification} hideNotification={this.hideNotification} getUserProfile={this.getUserProfile} userProfile={this.state.userProfile} />
                  <Route path="/error" render={() => <GenericError />} />
                  <Route path="/" render={() => <Default />} />
                </Switch> 
              </div>
          </div>
        </div>
      </Router>
    )
  }

  maintenance = () => {
   return (
    <div className="container">
      <div className="row">
        <div className="translate-dropdown-align">
          <GoogleTranslate />
        </div>
        <img src={ require('./logo.jpg') } className="App-logo" name="logo"  alt="City of Seattle"/>
        <div className="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-10 col-md-offset-1">
          <Maintenance start={process.env.REACT_APP_START_MAINTENANCE} end={process.env.REACT_APP_END_MAINTENANCE} />
        </div>
      </div>
    </div>
   )
  }

  render() {
    if(process.env.REACT_APP_MAINTENANCE === "true") {
      return this.maintenance()
    } else {
      return this.renderApp()
    }
    
    
  }
}

export default App;
